import React, { useRef, useState, useEffect } from 'react';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import {
  ButtonsContainer,
  HeroTextPairing,
  HeroVideoContainer,
  HeroVideoWrapper,
  RegistryHeroTextColumn,
  StyledSection,
  RegistryHeroBottomWave,
  StyledButton,
  StyledContainer,
  StyledFeature,
} from './HeroSectionV2.styles';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import ReactHtmlParser from 'react-html-parser';
import { getRootUrl } from '@utils/urlHelpers.util';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';
import { useTranslation } from 'react-i18next';
import { JoykitIcon } from '@components/JoykitIcon';

interface RegistryHeroSectionProps {}

export const HeroSectionV2: React.FC<RegistryHeroSectionProps> = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const isMobile = useThemeMediaQuery('below_sm');
  const isTablet = useThemeMediaQuery('sm');
  const isLaptop = useThemeMediaQuery('md');
  const isDesktop = useThemeMediaQuery('lg');
  const isLargeScreen = useThemeMediaQuery('xl');
  const [heroVideoUrl, setHeroVideoUrl] = useState('');
  const { t } = useTranslation('registry');
  const registryHero = t('registryHero');

  useEffect(() => {
    if (isLargeScreen) {
      setHeroVideoUrl('https://player.vimeo.com/external/531025176.hd.mp4?s=b5bcba443950445aa9c9174a0727b526f0bf2bf0&profile_id=175');
    } else if (isDesktop) {
      setHeroVideoUrl('https://player.vimeo.com/external/531025176.hd.mp4?s=b5bcba443950445aa9c9174a0727b526f0bf2bf0&profile_id=174');
    } else if (isLaptop || isTablet) {
      setHeroVideoUrl('https://player.vimeo.com/external/531025176.sd.mp4?s=08a91d592ccfa7638249ed12666112b15a24196a&profile_id=165');
    } else if (isMobile) {
      setHeroVideoUrl('https://player.vimeo.com/external/531025176.sd.mp4?s=08a91d592ccfa7638249ed12666112b15a24196a&profile_id=164');
    } else {
      setHeroVideoUrl('https://player.vimeo.com/external/531025176.hd.mp4?s=b5bcba443950445aa9c9174a0727b526f0bf2bf0&profile_id=175');
    }
  }, [setHeroVideoUrl, isMobile, isTablet, isLaptop, isDesktop, isLargeScreen]);
  return (
    <StyledSection as="section" ref={sectionRef} id="Registry_Hero">
      <HeroVideoContainer>
        <HeroVideoWrapper>
          <div id="registry-hero-video-overlay" />
          <video
            muted
            loop
            autoPlay
            preload="auto"
            src={heroVideoUrl}
            poster={cloudAssetUrl('registry-v2/registry-hero/registry-hero-static-v3.jpg')}
            playsInline
          />
        </HeroVideoWrapper>
      </HeroVideoContainer>
      <RegistryHeroTextColumn verticalAlign="center">
        <Columns.Column width={12}>
          <Flex flexDirection={'column'} alignItems={'center'}>
            <HeroTextPairing
              eyebrowVariant="sectionEyeBrow20"
              eyebrowColor="mono7"
              eyebrowTagName="h1"
              title={ReactHtmlParser(registryHero.titleV2)}
              titleVariant="hed72Hero"
              titleColor="mono7"
              bodyVariant="dek20"
              bodyColor="mono7"
              bodyTagName="h2"
              marginTop={[13, 0]}
              marginBottom={7}
              alignment={'center'}
            />
            <StyledContainer>
              {registryHero.features.map((feature, idx) => (
                <Flex key={idx} alignItems="center">
                  <JoykitIcon name="checkmark" color="white" />
                  <StyledFeature tagName="p" variant="sectionEyeBrow20" color="white">
                    {feature}
                  </StyledFeature>
                </Flex>
              ))}
            </StyledContainer>
            <ButtonsContainer>
              <StyledButton
                id="registryHeroGetStartedBtn"
                variant="darkGetStartedBtn"
                forwardedAs={'a'}
                href={getCreateWeddingUrl('registry')}
              >
                {registryHero.cta1Label}
              </StyledButton>
              <StyledButton
                id="registryHeroFindCoupledBtn"
                variant="darkfindACoupleBtn"
                forwardedAs={'a'}
                href={getRootUrl('/find-a-couple')}
              >
                {registryHero.cta2Label}
              </StyledButton>
            </ButtonsContainer>
          </Flex>
        </Columns.Column>
      </RegistryHeroTextColumn>
      <RegistryHeroBottomWave src="home/hero/wave-mobile.svg" alt={'registy hero bottom wave'} isEagerLoading />
    </StyledSection>
  );
};
